import { render, staticRenderFns } from "./DiamondButton.vue?vue&type=template&id=51606020&"
import script from "./DiamondButton.vue?vue&type=script&lang=js&"
export * from "./DiamondButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports